<template>
  <v-dialog
    v-model="isActive"
    width="400"
  >
    <v-card>
      <v-card-title class="bg-doorMainColor">エラー</v-card-title>
      <v-card-text style="margin: 1rem auto;">
        <div>通信エラーが発生しました。</div>
        <div>お手数ですが再度送信ボタンをクリックしてください。</div>
      </v-card-text>
      <v-divider></v-divider>
      <v-spacer></v-spacer>
      <v-row justify="center" align-content="center" class="my-3">
          <v-btn
            dark
            color="doorAccentColor"
            @click="isActive = false"
          >
          閉じる
          </v-btn>
      </v-row>
    </v-card>
  </v-dialog>
</template>
<script>
import { defineComponent, ref } from 'vue'

export default defineComponent({
  props: {
    isOpen: {
      type: Boolean,
      require: true,
    },
  },
  setup(props) {
    const isActive = ref(props.isOpen)
    return {
      isActive
    }
  }
})
</script>
